/**
 * Why Push tracking is unavailable for ONE order, or null.
 *
 * Two reasons, and the per-order one is why this is not simply the system-wide string: where the
 * RETAILER already holds tracking for the order, sending ours does not ADD a tracking number, it
 * REPLACES the one the customer is following. The server refuses it; this is so the button says
 * so instead of looking live and failing at the end.
 *
 * One exception, the same one the server makes: the retailer holds OUR number (the order's own
 * `trackingNumber`) on an order it still has in SHIPPING. Sending it again replaces nothing, and
 * it is the push that gets the order validated as shipped. Past SHIPPING the retailer is finished
 * with the order, whoever's number it holds. Numbers are compared ignoring case and spacing.
 *
 * The retailer's own tracking is checked FIRST, even though the inventory equivalent checks the
 * system-wide reason first. Both put the more fundamental blocker in front: no setting an admin
 * can reach makes this order pushable when the retailer already has its tracking.
 *
 * Used by both per-order Push tracking buttons - the Connector page and a brand's own order list
 * - so the two cannot disagree about the same order.
 */
const sameNumber = (a, b) => {
  const norm = (v) => String(v ?? '').replace(/\s+/g, '').toUpperCase();
  return norm(a) !== '' && norm(a) === norm(b);
};

export const trackingPushUnavailable = (order, systemWideReason) => {
  const theirs = order?.retailerTracking;
  const ourOwnStillShipping = order?.miraklStatus === 'SHIPPING'
    && sameNumber(theirs?.number, order?.trackingNumber);
  if (theirs?.number && !ourOwnStillShipping) {
    const carrier = theirs.carrier ? `${theirs.carrier} ` : '';
    return `${order?.marketplace?.name || 'The retailer'} already shipped this order `
      + `(${carrier}${theirs.number}). Sending ours would replace that number.`;
  }
  return systemWideReason || null;
};
